import { useSetRecoilState } from "recoil"
import { localMuteAtom } from "../../recoil/atoms/local-mute"
import useMeetingClient from "../useMeetingClient"

const useIncomingRTCAudio = () => {
  const meetingClient = useMeetingClient()
  const setIsMuted = useSetRecoilState(localMuteAtom)

  /** This function mutes all other participates incoming audio.  */
  const muteRTCIncomingAudio = () => {
    try {
      const remoteUserList = meetingClient?.rtc?.getRemoteUsersList()

      remoteUserList.forEach(id => {
        const { audioTrack } = meetingClient.getMediaTracks(id)
        if (audioTrack) {
          audioTrack.stop()
        }
      })
      meetingClient?.rtc?.toggleAllMuteUsers(true)
      setIsMuted(true)
    } catch (e) {
      console.error("muteRTCIncomingAudio()", e.message)
    }
  }

  /** This function unmutes all other participates incoming audio.  */
  const unmuteRTCIncomingAudio = () => {
    try {
      const remoteUserList = meetingClient?.rtc?.getRemoteUsersList()
      remoteUserList.forEach(id => {
        const { audioTrack } = meetingClient.getMediaTracks(id)
        if (audioTrack) {
          audioTrack.play()
          audioTrack.setVolume(100)
        }
      })
      meetingClient.rtc?.toggleAllMuteUsers(false)
      setIsMuted(false)
    } catch (e) {
      console.error("unmuteRTCIncomingAudio() ", e.message)
    }
  }

  return { muteRTCIncomingAudio, unmuteRTCIncomingAudio }
}

export default useIncomingRTCAudio
